module.exports = __webpack_public_path__ + "static/img/stars.c25ce7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stars.png
// module id = diih
// module chunks = 1